import BaseModel from 'src/model/base.model';

class HandlerModel extends BaseModel {
  public id: number = 0;
  public name: string = '';
}

export default HandlerModel;
